import { render, staticRenderFns } from "./ChallengesMenu.vue?vue&type=template&id=3aca8e64&"
import script from "./ChallengesMenu.vue?vue&type=script&lang=js&"
export * from "./ChallengesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports